export const CMS_COMPONENT_BUTTON_INPUT_KINDS = [
  'none',
  'image_file',
  'workspace_prefill',
] as const;

export type CmsComponentButtonInputKind =
  (typeof CMS_COMPONENT_BUTTON_INPUT_KINDS)[number];

export function cmsComponentButtonInputRequiresWorkspace(
  inputKind: CmsComponentButtonInputKind
) {
  return inputKind === 'image_file' || inputKind === 'workspace_prefill';
}

export function readCmsComponentButtonWorkspaceInputError(
  inputKind: CmsComponentButtonInputKind
) {
  return inputKind === 'workspace_prefill'
    ? {
        code: 'ADMIN_V2_WORKSPACE_PREFILL_REQUIRES_WORKSPACE_ACTION',
        message: 'Workspace prefill buttons must open the workspace.',
      }
    : {
        code: 'ADMIN_V2_IMAGE_FILE_REQUIRES_WORKSPACE_ACTION',
        message: 'Image upload buttons must open the workspace.',
      };
}
